import { useRef as e } from "react";
var s = function() {
  var r = e(!0);
  return r.current ? (r.current = !1, !0) : r.current;
};
export {
  s as useIsFirstRender
};
